import cn from "classnames";
import { splitKeyFromProps } from "helpers/reactTableProps";
import React, { useEffect } from "react";
import { useFlexLayout, useTable } from "react-table";

export default function Table(props) {
    useEffect(() => {
        props.getList();
    }, []);
    const instance = useTable({ columns: props.columns, data: props.items }, useFlexLayout);
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = instance;
    return (
        <div className="list__body-wrap container-fluid pb-3">
            <div className={cn("list__body d-flex flex-column", { loading: props.loading })}>
                <div {...getTableProps()} className="r-table table-sm" onScroll={props.scrollHandle}>
                    <div className="r-table__thead">
                        {headerGroups.map((headerGroup, i) => {
                            const { key: headerGroupKey, props: headerGroupProps } = splitKeyFromProps(
                                headerGroup.getHeaderGroupProps(),
                            );
                            return (
                                <div key={headerGroupKey ?? i} {...headerGroupProps} className="tr">
                                    {headerGroup.headers.map((column, i) => {
                                        const { key: headerKey, props: headerProps } = splitKeyFromProps(
                                            column.getHeaderProps({
                                                title: "",
                                                className: cn("th", {
                                                    [column.headerClassName]: !!column.headerClassName,
                                                }),
                                            }),
                                        );
                                        return (
                                            <div key={headerKey ?? i} {...headerProps}>
                                                <div className="r-table__column-title">{column.render("Header")}</div>
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </div>
                    <div className="r-table__tbody" {...getTableBodyProps()}>
                        {rows.map((row, rowIndex) => {
                            prepareRow(row);
                            const { key: rowKey, props: rowProps } = splitKeyFromProps(row.getRowProps());
                            return (
                                <div key={rowKey ?? rowIndex} {...rowProps} className="tr">
                                    {row.cells.map((cell, i) => {
                                        const { key: cellKey, props: cellProps } = splitKeyFromProps(
                                            cell.getCellProps({
                                                className: cn("td", {
                                                    [cell.column.columnClassName]: !!cell.column.columnClassName,
                                                }),
                                            }),
                                        );
                                        return (
                                            <div key={cellKey ?? i} {...cellProps}>
                                                {cell.render("Cell")}
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}
